import React, { useState } from "react";
import { classNamesFunction, IPersonaSharedProps, Persona, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { IStepStatusPropsStyles, IStepStatusStyles, IStepStatusProps } from "./stepStatus.types";
import { useTranslation } from "react-i18next";
import { WorkFlowStep, WorkFlowStepStatus } from "../../../../../models/workflowStep";
import { WorkFlowStepDetails } from "../common";
import { StepCircleStatus } from "./stepStatus.styles";
import { User } from "../../../../../models/user";

const getClassNames = classNamesFunction<IStepStatusPropsStyles, IStepStatusStyles>();

const getCircleStatus = (item: WorkFlowStepDetails<WorkFlowStep>) => {
    if (item.isUnusedStep)
        return StepCircleStatus.IdleAndPrevRefused;
    if ((item.step.status === WorkFlowStepStatus.Idle || item.step.status === WorkFlowStepStatus.ToBeApproved) && item.prevStep?.status !== WorkFlowStepStatus.Refused)
        return StepCircleStatus.IdleOrPendingAndPrevNotRefused;
    if ((item.step.status === WorkFlowStepStatus.Approved))
        return StepCircleStatus.Approved;
    if ((item.step.status === WorkFlowStepStatus.Refused))
        return StepCircleStatus.Refused;

    return StepCircleStatus.IdleOrPendingAndPrevNotRefused;
}

const mapUserToPersona = (user: User): IPersonaSharedProps | undefined => {
    return {
        text: `${user.firstName} ${user.lastName}`,
        secondaryText: user.email,
        imageInitials: `${user.firstName[0].toUpperCase() || ""}${user.lastName[0].toUpperCase() || ""}`
    }
}

export const StepStatusBase = (props: IStepStatusProps) => {
    const [collapsed, setCollapsed] = useState(false);
    const { t } = useTranslation(['stepStatus', 'workflowDetails']);
    const classNames = getClassNames(props.styles, { theme: props.theme, className: props.className, collapsed: collapsed, lastStep: props.item.isLastStep, status: getCircleStatus(props.item) });

    return (
        <>
            <Stack className={classNames.rowMargin} horizontal tokens={{ childrenGap: 10 }}>
                <StackItem>
                    <div onClickCapture={() => { setCollapsed(!collapsed) }} className={classNames.stepStatus}></div>
                </StackItem>
                <StackItem style={{ width: '95%' }}>
                    <Stack tokens={{ childrenGap: 5 }}>
                        <StackItem style={{ width: 'fit-content' }}>
                            <TooltipHost className={classNames.tooltip} content={props.item.step.name}>
                                <div className={classNames.stepName} >
                                    {t('title', { 'order': props.item.step.order + 1 })} {props.item.step.name}
                                </div>
                            </TooltipHost>
                        </StackItem>
                        {!collapsed ?
                            <StackItem >
                                <Stack className={classNames.approverSection} tokens={{ childrenGap: 15 }}>
                                    {props.item.step.status !== WorkFlowStepStatus.Idle && props.item.step.approvers.map(x => {
                                        return <Stack horizontal verticalAlign="center" key={x.user.id} >
                                            <StackItem>
                                                <div className={classNames.approverInitialLettersSection}>
                                                    <Persona
                                                        {...mapUserToPersona(x.user)}
                                                        hidePersonaDetails
                                                        onRenderInitials={(props) => <TooltipHost content={props?.text}><div style={{ cursor: 'pointer' }}>{props?.imageInitials}</div></TooltipHost>}
                                                        coinProps={{
                                                            styles: {
                                                                initials: {
                                                                    borderRadius: 0
                                                                }
                                                            }
                                                        }}
                                                        coinSize={30}
                                                    />
                                                </div>
                                            </StackItem>
                                            <StackItem>{`${x.user.firstName} ${x.user.lastName}`} {props.isSummary ? '' : `${t('userAction')} ${t(`stepStatus:approverStatus.${x.status}`)}`} </StackItem>
                                        </Stack>
                                    })}
                                </Stack>

                            </StackItem> : ''}
                    </Stack>
                </StackItem>
            </Stack>
        </>
    );
}